// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var SalesEntityListSettingsController = function ($scope, salesEntitiesService, gettextCatalog, gettext) {
    $scope.salesEntities = [];
    const pageSize = 21;

    function init() {

        $scope.salesEntities = $scope.paginator(function (options, callback) {
            return salesEntitiesService.query(options,
                function (result) {
                    callback();
                });
        }, {}, pageSize);
    }

    $scope.delete = function (id) {
        $scope.yesCancel(_txt(gettext('Delete Sales Entity')), _txt(gettext('Are you sure?')),
            function () {
                salesEntitiesService.remove({ salesEntityId: id }, function () {
                    init();
                })
            });

        init();
    }

    function _txt(msg) {
        return gettextCatalog.getString(msg);
    }

    init();
};
SalesEntityListSettingsController.$inject = ['$scope', 'SalesEntities', 'gettextCatalog', 'gettext'];
